import { render, staticRenderFns } from "./CurrentPurchaseStockAdjust.vue?vue&type=template&id=2f144606&"
import script from "./CurrentPurchaseStockAdjust.vue?vue&type=script&lang=js&"
export * from "./CurrentPurchaseStockAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports